/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { token } from '@atlaskit/tokens';

import { overflowEllipsis } from 'src/styles/mixins';

export const Row = styled.div({
  display: 'flex',
  marginBottom: token('space.200'),
});

export const Column = styled.div({
  flex: 1,
  minWidth: 0,
  padding: `0 ${token('space.100')}`,
  '&:first-child': {
    paddingLeft: 0,
  },
  '&:last-child': {
    paddingRight: 0,
  },
});

export const Label = styled.div({
  font: token('font.body.UNSAFE_small'),
  fontWeight: token('font.weight.semibold'),
  color: token('color.text.subtlest'),
  marginTop: 0,
});

export const Value = styled.span(overflowEllipsis());

export const Card = styled.div({
  '& + &': {
    marginTop: token('space.150'),
  },
});
